import './mortongolf/style';
import FormStructure from './mortongolf/form_structure';

export default FormStructure;